import { render, staticRenderFns } from "./ChooseFile.vue?vue&type=template&id=bc8ec5bc&scoped=true"
import script from "./ChooseFile.vue?vue&type=script&lang=js"
export * from "./ChooseFile.vue?vue&type=script&lang=js"
import style0 from "./ChooseFile.vue?vue&type=style&index=0&id=bc8ec5bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8ec5bc",
  null
  
)

export default component.exports